import spinnerImg from '../../tnew/images/busy-spinner.gif';

const containerClassName = 'tn-busy-spinner';
const imageClassName = 'tn-busy-spinner__image';

const busySpinner = `
<div class="${containerClassName}">
  <img class="${imageClassName}" src="${spinnerImg}" alt="Loading" />
</div>`;

export default busySpinner;

export { imageClassName, containerClassName };
